/**
 * Atop Drop slots, while today's plan cuts or clamps a slot for the daily
 * SMS cap (20/10/2026): how many, whose cap and how much a day, and the
 * button that opens the master config's Auto-send tab to change it. The
 * cut rows carry the same chip.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Ban } from 'lucide-react';

import { Button } from '@/components/ui';

import { useSectionSources } from '../../../master/section-sources';
import { type CapCuts, capCutWords } from '../../../../shared/cap/cap-cuts';
import { capLineWords } from './cap-words';

export const CapLine: FC<{ cuts: CapCuts }> = ({ cuts }) => {
  const { masterRef, openMaster } = useSectionSources();
  const words = capCutWords(cuts);
  if (!words) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-md border border-destructive/30 bg-destructive/5 px-3 py-2 text-xs" role="status" data-testid="cap-line">
      <Ban className="h-3.5 w-3.5 shrink-0 text-destructive" aria-hidden />
      <span className="min-w-0 flex-1 text-foreground/90">{capLineWords(words, masterRef)}</span>
      {masterRef ? (
        <Button size="sm" variant="outline" className="h-7 text-xs" onClick={() => openMaster(masterRef.id, 'autosend')}>
          Edit the cap
        </Button>
      ) : null}
    </div>
  );
};
